import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { Grid } from "../../app/core/components/grid";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import { Helper } from "../core/util/helper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { AppBaseProps, CommonApp, Entity, Metadata } from "../core/components/commonApp";
import { AppHelper } from "../appHelper";
import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import { Config } from "../core/config/config";
import { FAIcon } from "../core/components/faIcon";
import { Dialog, DialogProps } from "../core/components/dialog";
import { DropDownList } from "../core/components/dropDownList";
import { ComponentHelper } from "../core/util/componentHelper";
import { DialogHelper } from "../core/util/dialogHelper";
import { BaseField } from "../core/components/baseComponentProps";
import { MetadataRegion } from "../core/components/region";
import { KeyValuePair } from "../commonInterfaces";
import React from "react";
import ReactDOM from "react-dom";
export default class Countries extends React.Component<any, { gridData: GridItem[]}> {

    private gridOptions: kendo.ui.GridOptions = {
        sortable: true,
        pageable: false,
        groupable: false,
        filterable: true,
        selectable: true,
        resizable: true,
        scrollable: true,
        editable: false,
        columns: [
            {
                field: "Name",
                title: Helper.getTranslation("Field.Adresse.land")
            },
            {
                field: "IsoCode",
                title: Helper.getTranslation("WebSMS.GeneralSettings.Spesen.Landkf")
            }
            
        ]
    };
    private metaData: Metadata = {
        rightDrawerContainer: {
            visible: true,
            width: 400,
            multipleComponents: [
                {
                    moduleName: "app/core/components/iframe",
                    iconName: "question-circle",
                    renderAlways: true,
                    props: {
                        url: "{{helpBaseUrl}}/{{helpVersion}}/{{helpLanguage}}/2b1df8c7-4136-4cb9-a091-13872ad1034e.html"
                    },
                    type: "rightdrawer_help",
                }
            ]
        },
        menuDataSource: [
            {
                type: "save"
            }
//            {
                //onClick: "remove()",
                //type: "delete"
//            }

        ],
        tabs: [
            {
                title: "",
                regions: [
                    {
                        title: Helper.getTranslation("Server.Allgemein"),
                        visible: true,
                        id: kendo.guid(),
                        fields: [
                            {
                                visible: true,
                                required: true,
                                name: Helper.getTranslation("GeoMap.Country"),
                                model: "entity.FallbackName",
                                type: "textbox",
                                maxLength: 128
                            } as BaseField,
                            {
                                visible: true,
                                required: true,
                                name: Helper.getTranslation("WebSMS.GeneralSettings.Spesen.Landkf"),
                                model: "entity.IsoCode",
                                type: "textbox",
                                maxLength: 8
                            } as BaseField,
                            {
                                name: Helper.getTranslation("WebSMS.Common.Timezone"),
                                model: "entity.Timezone",
                                visible: true,
                                required: false,
                                readOnly: false,
                                type: "is-search-field",
                                listWidth: 250,
                                autocompleteEnabled: true,
                                autocompleteTemplate: "<table cellspacing='0' style='table-layout:fixed; width:250px'><colgroup><col style='width: 25px' /></colgroup><tr><td style='vertical-align:top; word-wrap: break-word'>${data.Key}</td></tr></table>",
                                autocompleteUrl: "TimeZoneLookup/FindIanaTimeZones",
                                autocompleteDataTextField: "Key",
                                searchButtonEnabled: false,
                            } as BaseField,
                            {
                                visible: true,
                                type: "kendo-drop-down-list",
                                required: false,
                                model: "entity.KalenderId",
                                name: Helper.getTranslation("Field.Ressource.kalenderid"),
                                readOnly: false,
                                dataSourceUrl: "ResourceLookup/GetKalender",
                                dataTextField: "Name",
                                dataValueField: "Id"
                            } as BaseField

                        ]
                    },
                    {
                        title: Helper.getTranslation("BrowserTitle.Translations"),
                        fields: [
                            {
                                model: "entity.Translations",
                                name: "Translations",
                                type: "dynamic",
                                visible: true,
                                readOnly: "entity.ReadOnly",
                                labelAndControlCombined: true,
                                moduleName: "app/editIndividualFields/editTranslations",
                                maxLenght: 128,
                                columnName: Helper.getTranslation("BrowserTitle.Resource.Available")
                            } as BaseField
                        ],
                        type: "region"
                    } as MetadataRegion,
                    {
                        title: Helper.getTranslation("WebSMS.Country.States"),
                        size: [
                            {
                                container: "extrasmall",
                                width: "12/12"
                            },
                            {
                                container: "small",
                                width: "12/12"
                            },
                            {
                                container: "medium",
                                width: "4/12"
                            },
                            {
                                container: "large",
                                width: "4/12"
                            },
                            {
                                container: "extralarge",
                                width: "4/12"
                            }
                        ],
                        fields: [
                            {
                                visible: true,
                                type: "dynamic",
                                model: "",
                                labelAndControlCombined: true,
                                componentName: "renderStatesGrid()",
                                name: "States"
                            } as BaseField
                        ]
                    } as MetadataRegion,
                    {
                        title: Helper.getTranslation("Beleg.Spesen"),
                        visible: "!entity.IsNew",
                        size: [
                            {
                                container: "extrasmall",
                                width: "12/12"
                            },
                            {
                                container: "small",
                                width: "12/12"
                            },
                            {
                                container: "medium",
                                width: "4/12"
                            },
                            {
                                container: "large",
                                width: "4/12"
                            },
                            {
                                container: "extralarge",
                                width: "4/12"
                            }
                        ],
                        fields: [
                            {
                                type: "dynamic",
                                model: "",
                                labelAndControlCombined: true,
                                componentName: "renderExpenses()",
                                name: "Expenses",
                                visible: true,
                                visibleCondition: "!entity.IsNew"
                            } as BaseField
                        ]
                    } as MetadataRegion
                ]
            },

        ]
    };

    constructor(props) {
        super(props)
        this.state = {
            gridData: []
        }
        this.loadGridData();
    }

    private loadGridData = async () => {
        const data = await HTTPService.get<GridItem[]>("Country/GetAllSelectionItems");
        this.setState({gridData: data})
    }

    private loadCountry = async (id: string) => {
        const { Code, Message, Data } = await HTTPService.get<JsonResultClass<CountryEntity>>(`Country/GetById?id=${id}`);
        if (Code == 0) {
            return Data;
        } else {
            NotificationHelper.showErrorMessage(Message);
            return null;
        }

    }

    private onButtonClick = async (type: ToolBarStandardButtonType, gridItem: GridItem) => {
        let entity: CountryEntity;
        switch (type) {
            case ToolBarStandardButtonType.EDIT:
                entity = await this.loadCountry(gridItem.Id);
                break;
            case ToolBarStandardButtonType.NEW:
                entity = {
                    FallbackName: "",
                    Id: kendo.guid(),
                    IsNew: true,
                    IsoCode: "",
                    IsWatchable: false,
                    IsWatched: false,
                    KalenderId: null,
                    RecordRight: {
                        CanRead: true,
                        CanWrite: true
                    },
                    Timezone: "",
                    Translations: [],
                    States: [],
                    IndividualFields: {},
                    Expenses: []
                };
                break;
            case ToolBarStandardButtonType.DELETE:
                const { Code, Message } = await HTTPService.get<JsonResultClass>(`Country/Delete?id=${gridItem.Id}`);
                if (Code == 0) {
                    NotificationHelper.showSuccessMessage(Helper.getTranslation("WebCRM.EditIndividualCategories.DeleteSuccessful"));
                    await this.loadGridData();
                } else {
                    NotificationHelper.showErrorMessage(Message);
                }
                break;
        }
        if (!entity)
            return;

        this.openSheet(entity);
    }

    private openSheet = (entity: CountryEntity) => {
        const props: CountryProps = {
            dataSources: {
 
            },
            metadata: this.metaData,
            entity: entity,
            isWindow: true,
            context: {},
            title: entity.IsNew ? Helper.getTranslation("WebSMS.Country.NewCountry") : entity.FallbackName
        }

        const sheet = General.Sheet.Manager.createSheet();
        sheet.bind(SheetEventType.Close, this.loadGridData);

        sheet.show(() => {
            sheet.mountContent(Country, props);
        });
    }

    render() {
        const standardButtons: Array<ToolBarStandardButton> = [
            { type: ToolBarStandardButtonType.NEW, caption: Helper.getTranslation("Standard.Neu"), enabled: true },
            { type: ToolBarStandardButtonType.EDIT, caption: Helper.getTranslation("Standard.Editieren"), enabled: true },
            { type: ToolBarStandardButtonType.DELETE, caption: Helper.getTranslation("Standard.Loeschen"), enabled: true }
        ];

        return (
            <div className="flex-container">
                <Grid
                    standardButtons={standardButtons}
                    data={this.state.gridData}
                    options={this.gridOptions}
                    id="countries"
                    onClickStandardButton={this.onButtonClick}
                />
            </div>
        );
    }
}

interface GridItem {
    Id: string;
}


interface BaseCountryEntity extends Entity {
    Id: string;
    FallbackName: string;
    IsoCode: string;
    KalenderId: number;
    Timezone: string;
    Translations: KeyValuePair<number, string>[]
}

interface CountryEntity extends BaseCountryEntity {
    States: StateEntity[];
    Expenses: KeyValuePair<string, string>[]
}

interface StateEntity extends BaseCountryEntity {
    Abbreviation: string;
}


interface CountryProps extends AppBaseProps {
    entity: CountryEntity;
}

class Country extends React.Component<CountryProps, any>{
    private common = new AppHelper();

    constructor(props) {
        super(props);
        this.common.init(this);
    }

    save = async () => {
        if (!this.common.validate()) 
            return;
        const { Code, Message, Data } = await HTTPService.post<JsonResultClass<CountryEntity>>("Country/Save", { model: this.props.entity })
        if (Code == 0) {
            this.common.updateSheetTitle(this.props.entity.FallbackName);
            Helper.updateEntity(this.props.entity, Data);
            NotificationHelper.showSuccessMessage(Helper.getTranslation("Standard.Msg.SpeichernErfolgreich"))
        } else {
            NotificationHelper.showErrorMessage(Message)
        }

        this.common.handlePostSave(Code === 0);
        this.setState({});
    }

    remove = async () => {
        //const isOk = await this.props.delete(this.props.entity.Land);
        //if (isOk) {
        //    General.Sheet.Manager.getTopMostSheet().hide();
        //}
    }

    renderStatesGrid = () => {
        const languageId = Config.user.languageId;

        const sortStates = (a: StateEntity, b: StateEntity) => {
            const name_a = (a.Translations.find(tr => tr.Key == languageId)?.Value ?? a.FallbackName).toLowerCase();
            const name_b = (b.Translations.find(tr => tr.Key == languageId)?.Value ?? b.FallbackName).toLowerCase();
            if (name_a < name_b) {
                return -1;
            } else if (name_a > name_b) {
                return 1;
            }
            return 0;
        }
        return <StatesGrid country={this.props.entity} states={this.props.entity.States.sort(sortStates)} onChange={(states) => { this.handleFieldChange({ model: "entity.States" }, states) }}></StatesGrid>
    }

    renderExpenses = () => {
        return <Expenses data={this.props.entity.Expenses} onChange={(states) => { this.handleFieldChange({ model: "entity.Expenses" }, states) }} />
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => { 
        if (!isInit) {
            this.common.handleFieldChange(field, value, dataItem);
        }
    }

    componentDidMount() {
        this.common.updateSheetTitle(this.props.title);
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

interface StatesGridProps {
    states: StateEntity[];
    onChange: (states: StateEntity[]) => void;
    country: CountryEntity
}

class Expenses extends React.Component<{ data: KeyValuePair<string, string>[], onChange: (data: KeyValuePair<string, string>[]) => void }, any>{
    private gridOptions: kendo.ui.GridOptions = {
        dataSource: {
            pageSize: 8
        },
        sortable: true,
        pageable: true,
        groupable: false,
        filterable: true,
        selectable: true,
        resizable: true,
        scrollable: true,
        editable: false,
        columns: [
            {
                field: "Value",
                title: Helper.getTranslation("Beleg.Spesen")
            }

        ]
    };

    constructor(props) {
        super(props)
    }

    private onButtonClick = async (type: ToolBarStandardButtonType, gridItem: KeyValuePair<string, string>) => {
        let data: KeyValuePair<string, string>[] = JSON.parse(JSON.stringify(this.props.data))
        switch (type) {
            case ToolBarStandardButtonType.NEW:
                const value = await this.addExpense();
                data.push(value);
                break;
            case ToolBarStandardButtonType.DELETE:
                data = data.filter(d => d.Key != gridItem.Key)
                break;
        }
        data = data.filter(this.onlyUnique).sort((a, b) => {
            if (a.Value < b.Value) {
                return -1;
            } else if (a.Value > b.Value) {
                return 1;
            }
            return 0;
        });


        this.props.onChange(data)
    }

    private onlyUnique = (value: KeyValuePair<string, string>, index: number, array: KeyValuePair<string, string>[]) => {
        return array.findIndex(item => item.Key == value.Key) === index;
    }

    private addExpense = () => {
        return new Promise<KeyValuePair<string, string>>((resolve) => {
            const targetElement = $("<div>");
            $("body").append(targetElement);

            const removeDialog = () => {

                ReactDOM.unmountComponentAtNode(targetElement[0]);
                targetElement[0].remove();
            }
            let value: KeyValuePair<string, string>;
            const dialogProps: DialogProps = {
                title: "",
                actions: [
                    {
                        label: Config.translations.cancel,
                        action: () => {
                            resolve(null)
                        }
                    },
                    {
                        label: Config.translations.ok,
                        action: () => {
                            resolve(value)

                        },
                        primary: true
                    }
                ],
                afterClose: () => {

                },
                width: 450
            };
            const props = ComponentHelper.createFactory().getDefaultDropDownProps();
            props.onChange = (_, __, dataItem) => {
                if (dataItem) {
                    value = {
                        Key: dataItem.Landdeutsch,
                        Value: dataItem.Land
                    }
                } else {
                    value = null;
                }
                
            }
            props.value = value?.Key;
            props.field.dataSourceUrl = "AddressLookup/GetSpesen";
            props.field.dataValueField = "Landdeutsch";
            props.field.dataTextField = "Land";


            ReactDOM.render(
                <Dialog {...dialogProps} open={true} title={Helper.getTranslation("WebSMS.Country.AddExpense")} >
                    <DropDownList {...props} />
                </Dialog >, targetElement[0]);


        })

    }

    render() {
        const standardButtons: Array<ToolBarStandardButton> = [
            { type: ToolBarStandardButtonType.NEW, caption: Helper.getTranslation("Standard.Add"), enabled: true },           
            { type: ToolBarStandardButtonType.DELETE, caption: Helper.getTranslation("Standard.Loeschen"), enabled: true }
        ];

        return (
            <div className="flex-container">
                <Grid
                    standardButtons={standardButtons}
                    data={this.props.data}
                    options={this.gridOptions}
                    id="countries_Expenses"
                    onClickStandardButton={this.onButtonClick}
                />
            </div>
        );
    }



}

class StatesGrid extends React.Component<StatesGridProps, {}>{
    private gridOptions: kendo.ui.GridOptions = {
        dataSource: {
            pageSize: 8
        },
        sortable: true,
        pageable: true,
        groupable: false,
        filterable: true,
        selectable: true,
        resizable: true,
        scrollable: true,
        editable: false,
        columns: [
            {
                field: "Name",
                title: Helper.getTranslation("BrowserTitle.Resource.Available")
            },
            {
                field: "IsoCode",
                title: Helper.getTranslation("WebSMS.GeneralSettings.Spesen.Landkf")
            }

        ]
    };
    private metaData: Metadata = {
        menuDataSource: [
            {
                type: "save"
            }
            //            {
            //onClick: "remove()",
            //type: "delete"
            //            }

        ],
        tabs: [
            {
                title: "",
                regions: [
                    {
                        title: Helper.getTranslation("Server.Allgemein"),
                        visible: true,
                        id: kendo.guid(),
                        fields: [
                            {
                                visible: true,
                                required: true,
                                name: Helper.getTranslation("BrowserTitle.Resource.Available"),
                                model: "entity.FallbackName",
                                type: "textbox",
                                maxLength: 128
                            } as BaseField,
                            {
                                visible: true,
                                required: true,
                                name: Helper.getTranslation("WebSMS.GeneralSettings.Spesen.Landkf"),
                                model: "entity.IsoCode",
                                type: "textbox",
                                maxLength: 8
                            } as BaseField,
                            {
                                visible: true,
                                required: false,
                                name: Helper.getTranslation("WebSMS.Country.Abbreviation"),
                                model: "entity.Abbreviation",
                                type: "textbox",
                                maxLength: 8
                            } as BaseField,
                            {
                                name: Helper.getTranslation("WebSMS.Common.Timezone"),
                                model: "entity.Timezone",
                                visible: true,
                                required: false,
                                readOnly: false,
                                type: "is-search-field",
                                listWidth: 250,
                                autocompleteEnabled: true,
                                autocompleteTemplate: "<table cellspacing='0' style='table-layout:fixed; width:250px'><colgroup><col style='width: 25px' /></colgroup><tr><td style='vertical-align:top; word-wrap: break-word'>${data.Key}</td></tr></table>",
                                autocompleteUrl: "TimeZoneLookup/FindIanaTimeZones",
                                autocompleteDataTextField: "Key",
                                searchButtonEnabled: false,
                            } as BaseField,
                            {
                                visible: true,
                                type: "kendo-drop-down-list",
                                required: false,
                                model: "entity.KalenderId",
                                name: Helper.getTranslation("Field.Ressource.kalenderid"),
                                readOnly: false,
                                dataSourceUrl: "ResourceLookup/GetKalender",
                                dataTextField: "Name",
                                dataValueField: "Id"
                            } as BaseField

                        ]
                    },
                    {
                        title: Helper.getTranslation("BrowserTitle.Translations"),
                        fields: [
                            {
                                model: "entity.Translations",
                                name: "Translations",
                                type: "dynamic",
                                visible: true,
                                readOnly: "entity.ReadOnly",
                                labelAndControlCombined: true,
                                moduleName: "app/editIndividualFields/editTranslations",
                                maxLenght: 128,
                                columnName: Helper.getTranslation("BrowserTitle.Resource.Available")
                            } as BaseField
                        ],
                        type: "region"
                    } as MetadataRegion
                ]
            },

        ]
    };

    private getGridOptions = () => {
        const onlyUnique = (value, index, array) => {
            return array.indexOf(value) === index;
        }
        const tmp = this.props.states.map(st => st.Timezone);
        tmp.push(this.props.country.Timezone)
        const showTimeZone = tmp.filter(tz => !Helper.isNullOrEmpty(tz)).filter(onlyUnique).length > 1
        const gridOptions: kendo.ui.GridOptions = JSON.parse(JSON.stringify(this.gridOptions));
        if (showTimeZone) {
            gridOptions.columns.push({
                field: "Timezone",
                title: Helper.getTranslation("WebSMS.Common.Timezone")

            })
        }
        return gridOptions;
    }

    constructor(props) {
        super(props)
    }

    private onButtonClick = async (type: ToolBarStandardButtonType, gridItem: {Id}) => {
        let entity: StateEntity;
        switch (type) {
            case ToolBarStandardButtonType.EDIT:
                entity = this.props.states.find(f => f.Id == gridItem.Id)
                break;
            case ToolBarStandardButtonType.NEW:
                entity = {
                    FallbackName: "",
                    Id: kendo.guid(),
                    IsNew: true,
                    IsoCode: this.props.country.IsoCode + "-",
                    IsWatchable: false,
                    IsWatched: false,
                    KalenderId: this.props.country.KalenderId,
                    RecordRight: {
                        CanRead: true,
                        CanWrite: true
                    },
                    Timezone: this.props.country.Timezone,
                    Translations: [],
                    Abbreviation: "",
                    IndividualFields: {}
                };
                break;
            case ToolBarStandardButtonType.DELETE:
                const isOk = await DialogHelper.confirm(Helper.getTranslation("Standard.Msg.Loeschen"))
                if (!isOk)
                    return;
                let data = this.props.states;
                data = data.filter(f => f.Id != gridItem.Id);
                this.props.onChange(data)
                break;
        }
        if (!entity)
            return;

        this.openSheet(entity);
    }

    private openSheet = (entity: StateEntity) => {
        const props: StateProps = {
            dataSources: {

            },
            metadata: this.metaData,
            entity: entity,
            isWindow: true,
            context: {},
            title: entity.IsNew ? Helper.getTranslation("WebSMS.Country.NewState") : entity.FallbackName,
            onSave: (state) => {
                const data = this.props.states;
                const index = data.findIndex(st => st.Id == state.Id);
                if (index == -1) {
                    data.push(state);
                } else {
                    data[index] = state;
                }
                this.props.onChange(data)
            }
        }

        const sheet = General.Sheet.Manager.createSheet();
        sheet.bind(SheetEventType.Close, () => {

        });

        sheet.show(() => {
            sheet.mountContent(State, props);
        });
    }

    render() {
        const standardButtons: Array<ToolBarStandardButton> = [
            { type: ToolBarStandardButtonType.NEW, caption: Helper.getTranslation("Standard.Neu"), enabled: true },
            { type: ToolBarStandardButtonType.EDIT, caption: Helper.getTranslation("Standard.Editieren"), enabled: true },
            { type: ToolBarStandardButtonType.DELETE, caption: Helper.getTranslation("Standard.Loeschen"), enabled: true }
        ];
        const data = this.props.states.map((state) => {
            return {
                Id: state.Id,
                Name: state.Translations.find(tr => tr.Key == Config.user.languageId)?.Value ?? state.FallbackName,
                IsoCode: state.IsoCode,
                Timezone: state.Timezone
            }
        });

        return (
            <div className="flex-container">
                <Grid
                    standardButtons={standardButtons}
                    data={data}
                    options={this.getGridOptions()}
                    id="countries"
                    onClickStandardButton={this.onButtonClick}
                />
            </div>
        );
    }
}

interface StateProps extends AppBaseProps {
    entity: StateEntity;
    onSave: (entity: StateEntity) => void
}

class State extends React.Component<StateProps, any>{
    private common = new AppHelper();

    constructor(props) {
        super(props);
        this.common.init(this);
    }

    save = async () => {
        if (!this.common.validate())
            return;
        const msg = this.props.entity.IsNew ? "{state} wurde hinzugefügt" : "{state} wurde bearbeitet";
        NotificationHelper.showSuccessMessage(msg.replace("{state}", this.props.entity.FallbackName));
        this.common.updateSheetTitle(this.props.entity.FallbackName);
        this.props.onSave(this.props.entity)
        this.common.handlePostSave(true);
        this.setState({});
    }

    remove = async () => {
  
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit) {
            this.common.handleFieldChange(field, value, dataItem);
        }
    }

    componentDidMount() {
        this.common.updateSheetTitle(this.props.title);
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}